import type { DevicePlatform } from "@kopi/contracts/codes";
import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

export interface RouterContext {
  queryClient: QueryClient;
  /** Detected once at the composition root (PRD ADR-04); screens never probe the runtime. */
  platform: DevicePlatform;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
});
